<template>
  <div class="channel">
    <div class="howto">
      <p class="title">{{ $t('nav4') }}</p>
      <div class="channel-img">
        <img
          v-if="$i18n.locale === 'en'"
          src="../assets/channel-en.png"
          alt=""
        />
        <img
          v-if="$i18n.locale === 'cn'"
          src="../assets/channel-cn.png"
          alt=""
        />
        <img
          v-if="$i18n.locale === 'TW'"
          src="../assets/channel-tw.png"
          alt=""
        />
      </div>
      <!-- <div class="flow">
        <ul class="flow-list">
          <li>{{ $t('step1') }}</li>
          <li>{{ $t('step2') }}</li>
          <li>{{ $t('step3') }}</li>
          <li>{{ $t('step4') }}</li>
          <li>{{ $t('step5') }}</li>
          <li>{{ $t('step6') }}</li>
        </ul>
      </div> -->
    </div>
    <div class="service">
      <p class="title">
        {{ $t('slogan') }}
      </p>
      <div class="content">
        <div class="contentA">
          <p>{{ $t('sloganTitle1') }}</p>
          <span>
            {{ $t('sloganContent1') }}
          </span>
        </div>
        <div class="contentB"></div>
      </div>
      <div class="content">
        <div class="contentA">
          <p>{{ $t('sloganTitle2') }}</p>
          <span>
            {{ $t('sloganContent2') }}
          </span>
        </div>
        <div class="contentB"></div>
      </div>

      <!-- <p class="title">{{$t('slogan')}}</p> -->
      <!-- <div class="article">
        <dl class="service-info">
          <dt><span class="txt">{{$t('before')}}</span></dt>
          <dd>{{$t('step7')}}</dd>
          <dd>{{$t('step8')}}</dd>
          <dd>{{$t('step9')}}</dd>
        </dl>
        <dl class="service-info">
          <dt><span class="txt">{{$t('middle')}}</span></dt>
          <dd>{{$t('step10')}}</dd>
          <dd>{{$t('step11')}}</dd>
        </dl>
        <dl class="service-info">
          <dt><span class="txt">{{$t('after')}}</span></dt>
          <dd>{{$t('step12')}}</dd>
          <dd>{{$t('step13')}}</dd>
          <dd>{{$t('step14')}}</dd>
        </dl>
      </div> -->
    </div>
    <div class="register">
      <div
        class="btn"
        @click="$router.push({ path: '/register', query: { type: 0 } })"
      >
        {{ $t('step15') }}
      </div>
    </div>
    <div class="needs">
      <p class="title">{{ $t('conputer1') }}</p>
      <p class="tips">{{ $t('conputer2') }}</p>
      <ul class="need-info">
        <li>
          <div class="type windows">
            <p class="name">{{ $t('conputer3') }}</p>
            <p class="desc">{{ $t('conputer4') }}</p>
          </div>
          <p>{{ $t('conputer5') }}{{ $t('colon') }}</p>
          <p>{{ $t('conputer6') }}</p>
          <p>{{ $t('conputer7') }}</p>
          <p>{{ $t('conputer8') }}</p>
          <p>{{ $t('conputer9') }}</p>
        </li>
        <li>
          <div class="type mac">
            <p class="name">{{ $t('conputer10') }}</p>
            <p class="desc">{{ $t('conputer11') }}</p>
          </div>
          <p>{{ $t('conputer5') }}{{ $t('colon') }}</p>
          <p>{{ $t('conputer6') }}</p>
          <p>Mac OS{{ $t('colon') }}10.11PC or later versions</p>
          <p>{{ $t('conputer8') }}</p>
          <p>{{ $t('conputer9') }}</p>
        </li>
        <li>
          <div class="type ipad">
            <p class="name">{{ $t('conputer12') }}</p>
            <p class="desc">{{ $t('conputer13') }}</p>
          </div>
          <p>iPad{{ $t('colon') }}</p>
          <p>
            {{ $t('conputer6') }}{{ $t('colon') }}iOS9.3PC or later versions
          </p>
          <p>{{ $t('conputer14') }}</p>
          <p>{{ $t('conputer9') }}</p>
        </li>
      </ul>
    </div>
    <Platform></Platform>
  </div>
</template>
<script>
import Platform from '@/components/Platform.vue'
export default {
  components: { Platform },
}
</script>
<style lang="scss" scoped>
.channel-img {
  width: 900px;
  text-align: center;
  margin: 60px auto;
  img {
    width: 100%;
    height: auto;
  }
}
.howto {
  background: #fff;
  padding: 77px 0 0;
  .title {
    font-size: 36px;
    color: #002147;
    text-align: center;
    line-height: 47px;
    width: 1120px;
    padding-bottom: 23px;
    margin: 0 auto;
    border-bottom: 1px solid #dbdbdb;
  }
}
.flow {
  padding: 147px 0 147px;
}
.flow-list {
  width: 1000px;
  height: 600px;
  background: url(../assets/flow3.png) no-repeat top center;
  position: relative;
  margin: 0 auto;
  li {
    position: absolute;
    width: 220px;
    padding: 0 20px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #99b4a0;
    font-weight: bold;
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      bottom: 350px;
    }
    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6) {
      top: 530px;
    }
    &:nth-child(1),
    &:nth-child(6) {
      left: 93px;
    }
    &:nth-child(2),
    &:nth-child(5) {
      left: 360px;
    }
    &:nth-child(3),
    &:nth-child(4) {
      left: 610px;
    }
  }
}
.register {
  text-align: center;
  .btn {
    border-radius: 20px;
    display: inline-block;
    padding: 20px 80px;
    background: #13b5b1;
    color: #fff;
    font-size: 20px;
  }
  .btn:hover {
    cursor: pointer;
    box-shadow: #0c7371 0 5px 20px inset;
  }
}
.service {
  width: 1000px;
  margin: 0 auto;
  padding: 40px;
  // background: #fff url(../assets/service2.png) no-repeat center bottom;
  height: 550px;
  text-align: center;
  position: relative;
  .title {
    font-size: 30px;
    line-height: 42px;
    margin-bottom: 80px;
    width: 100%;
  }
  .content {
    width: calc(50% - 120px);
    float: left;
    position: relative;
  }

  .content:last-child {
    float: right;
  }
  .contentA {
    word-break: normal;
    z-index: 2;
    position: absolute;
    display: block;
    width: 100%;
    min-height: 260px;
    background: #57c7d7;
    color: #fff;
    padding: 0 20px;
    p {
      font-size: 24px;
      padding: 20px 0;
    }
    span {
      display: inline-block;
      // text-align: justify;
      word-wrap: normal;
      padding: 0 20px;
      font-size: 18px;
    }
  }
  .contentB {
    z-index: 1;
    display: block;
    position: absolute;
    top: -30px;
    right: -30px;
    width: 100%;
    min-height: 260px;
    background: #152040;
  }
  .article {
    padding: 0 54px;
  }
  .service-info {
    float: left;
    width: 330px;
    height: 340px;
    background: #fbfbfb;
    border-radius: 5px;
    padding-top: 70px;
    margin: 0 17px;
    &:hover {
      background: #fff;
      box-shadow: 0 3px 21px rgba($color: #7b7b7b, $alpha: 0.16);
    }
  }
  dt {
    margin-bottom: 30px;
    .txt {
      font-weight: bold;
      font-size: 24px;
      color: #333;
      display: inline-block;
      padding-bottom: 20px;
      border-bottom: 5px solid #002147;
    }
  }
  dd {
    margin-top: 20px;
    font-size: 18px;
    color: #333;
  }
  .btn-register {
    position: absolute;
    bottom: 24px;
    padding: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 32px;
    color: #fff;
    font-weight: bold;
  }
}
.needs {
  padding-top: 120px;
  height: 600px;
  .title {
    font-size: 32px;
    text-align: center;
    line-height: 42px;
  }
  .tips {
    margin-top: 20px;
    text-align: center;
  }
}
.need-info {
  margin: 60px auto 0;
  overflow: hidden;
  width: 1200px;
  li {
    float: left;
    width: 333.3px;
    margin: 0 50px;
    &:nth-child(1) {
      margin-left: 0;
    }
    &:nth-child(3) {
      margin-right: 0;
    }
    & > p {
      margin-bottom: 5px;
      color: #333;
      line-height: 24px;
    }
  }
  .type {
    min-height: 115px;
  }
  .windows {
    padding-left: 74px;
    background: url(../assets/windows.png) no-repeat 0 5px;
  }
  .mac {
    background: url(../assets/mac.png) no-repeat 0 5px;
    padding-left: 90px;
  }
  .ipad {
    background: url(../assets/ipad2.png) no-repeat 0 8px;
    padding-left: 68px;
  }
  .name {
    font-size: 18px;
    line-height: 24px;
  }
  .desc {
    color: #555;
    margin-top: 10px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .service .title {
    font-size: 6vw;
    line-height: normal;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 48px;
  }
  // .service .contentA{
  //   min-height: auto;
  // }
  .channel-img {
    width: 100%;
  }
  .channel-img {
    margin: 0;
    margin-top: 20px;
  }
  .howto {
    padding: 0;
    .title {
      width: 100%;
      font-size: 8vw;
      line-height: normal;
      padding: 10px 0;
    }
  }
  .need-info .type {
    min-height: initial;
  }
  .flow-list,
  .service {
    width: 100%;
  }
  .service {
    padding: 0 40px;
    // padding: 0 20px;
    display: block;
    .contentB,.contentA{
      min-height: 220px;
    }
    .content {
      margin-bottom: 60px;
      min-height: 220px;
      position: relative;
      width: 100%;
    }
  }

  .needs {
    padding: 0;
    clear: both;
    .title {
      font-size: 22px;
    }
    .tips{
      font-size: 16px;
      margin: 20px 0;
    }
  }
  .register {
    display: none;
  }
  .need-info {
    margin: 0;
    width: 100%;
    padding: 10px;
    overflow: inherit;
    li {
      width: 100%;
      margin: 0;
      border: 1px solid #ccc;
      padding: 10px;
      margin-bottom: 20px;
    }
  }
}
</style>
<i18n>
{
  "cn": {
    "macOs":"",
    "ipadOs":"",
    "step1": "注册帐号",
    "step2": "等待团队审核及联系",
    "step3": "通过帐号审核",
    "step4": "选择老师",
    "step5": "预约上课时间",
    "step6": "在家轻松学习",
    "slogan": "发挥课堂最大效益 - 课前备课，课后随时复习",
    "before": "课前",
    "middle": "课中",
    "after": "课后",
    "step7": "预习视频",
    "step8": "点读课件",
    "step9": "口语练习",
    "step10": "1对1上课",
    "step11": "家长实时监控",
    "step12": "外教点评",
    "step13": "回访录像",
    "step14": "阶段测评",
    "step15": "立即注册",
    "conputer1": "设备要求",
    "conputer2": "满足其中一项即可",
    "conputer3": "笔记本或台式机 Windows系统",
    "conputer4": "摄像头+头戴式耳麦",
    "conputer5": "电脑",
    "conputer6": "操作系统",
    "conputer7": "以上",
    "conputer8": "处理器：CPUi3及以上，内存4G及以上（注：在上视频课堂时，需要CPU i5及以上的处理器）",
    "conputer9": "网络要求：不低于4Mbps",
    "conputer10": "Mac 电脑",
    "conputer11": "苹果笔记本或一体机无需任何附加设备",
    "conputer12": "iPad 平板电脑",
    "conputer13": "完全支持 iOS 平台移动设备",
    "conputer14": "硬件支持：iPad Air / iPad Air 2 / iPad Pro / iPad 2018以及更新款的iPad设备",
    "sloganTitle1":"课堂前",
    "sloganTitle2":"课堂后",
    "sloganContent1":"老师和学生均可预先上载课堂所需的文件及档案",
    "sloganContent2":"学生可自行录影课堂片段，课后随时重温课堂内容"
  },
  "TW": {
    "step1": "註冊帳號",
    "step2": "等待團隊審核及聯絡",
    "step3": "通過帳號審核",
    "step4": "選擇老師",
    "step5": "預約上課時間",
    "step6": "在家輕鬆學習",
    "slogan": "發揮課堂最大效益 - 課前備課，課後隨時複習",
    "before": "課前",
    "middle": "課中",
    "after": "課後",
    "step7": "預習視頻",
    "step8": "點讀課件",
    "step9": "口語練習",
    "step10": "1對1上課",
    "step11": "家長即時監控",
    "step12": "外教點評",
    "step13": "回訪錄影",
    "step14": "階段測評",
    "step15": "立即注册",
    "conputer1": "設備要求",
    "conputer2": "滿足其中一項即可",
    "conputer3": "筆記本或桌上型電腦 Windows系統",
    "conputer4": "監視器+頭戴式耳麥",
    "conputer5": "電腦",
    "conputer6": "作業系統",
    "conputer7": "PC：Windows7以上",
    "conputer8": "處理器：CPUi3及以上，記憶體4G及以上（注：在上視頻課堂時，需要CPU i5及以上的處理器）",
    "conputer9": "網絡要求：不低於4Mbps",
    "conputer10": "Mac 電腦",
    "conputer11": "蘋果筆記本或一體機無需任何附加設備",
    "conputer12": "iPad 平板電腦",
    "conputer13": "完全支持iOS平臺移動設備",
    "conputer14": "硬體支持：iPad Air / iPad Air 2 / iPad Pro / iPad 2018以及更新款的iPad設備",
    "sloganTitle1":"課堂前",
    "sloganTitle2":"課堂後",
    "sloganContent1":"老師和學生均可預先上載課堂所需的文件及檔案",
    "sloganContent2":"學生可自行錄影課堂片段，課後隨時重溫課堂內容"
  },
  "en": {
    "step1": "Register an account with us",
    "step2": "A member from our team will contact you",
    "step3": "Account approved",
    "step4": "Choose your Tutor",
    "step5": "Book lessons with your chosen Tutor",
    "step6": "Attend lessons in the comfort of your home",
    "slogan": "Maximise the benefits from your lessons - prepare in advance; revise anytime thereafter.",
    "before": "Before the lesson",
    "middle": "during the lesson",
    "after": "after the lesson",
    "step7": "Video Clips",
    "step8": "Docs",
    "step9": " ",
    "step10": "One-to-one tuition",
    "step11": "Parents can listen in, especially during the first lesson, to gauge an understanding of the high quality of lessons being carried out. ",
    "step12": " ",
    "step13": "Lesson replay",
    "step14": "Assessment at different stages ",
    "step15": "Registration",
    "conputer1": "Devices you need for your lesson",
    "conputer2": "You only need to meet one of the following requirements:",
    "conputer3": "Laptop or PC running on Windows ",
    "conputer4": "Webcam + Headset with Microphone  ",
    "conputer5": "Desktop",
    "conputer6": "Operating system",
    "conputer7": "PC：Windows 7 or later versions",
    "conputer8": "Processor: CPUi3 or above, minimum 4G memory（Note: during live video lessons, processor CPU i5 or above is required)",
    "conputer9": "Internet speed: minimum 4Mbps",
    "conputer10": "Apple Mac desktop or laptop",
    "conputer11": "laptop computers (or any other all-in-one PC) do not require additional equipment.",
    "conputer12": "iPad ",
    "conputer13": "Supports mobile device on iOS platform ",
    "conputer14": "Supported Device: iPad Air / iPad Air 2 / iPad Pro / iPad models from 2018 onwards ",
    "sloganTitle1":"Before the Lesson",
    "sloganTitle2":"After the Lesson",
    "sloganContent1":"Both the Tutor and the Student can upload documents and files in preparation for the lesson",
    "sloganContent2":"The Student can record lessons and revisit important discussions and points during lesson replay"
  }
}
</i18n>